import { React } from "react";
import { Col, Row } from "react-bootstrap";
import logo from "../assets/img/logo.jpg";

export const Newsletter = () => {
  return (
    <Col lg={12}>
      <div className="newsletter-bx wow slideInUp information">
        <Row>
          <Col lg={12} md={6} xl={5} className="left">
            <h1>
              <b>GEEKY TECHH</b>
            </h1>
            <p>Team:</p>
            <p>Sameer Ahmed</p>
            <p>Ali Shaikh</p>
            <p>Amanullah Shaikh</p>
            <p>Irfan Ansari</p>
            <hr></hr>
            <p>Email: geekytechh@gmail.com , geekytechh@outlook.com</p>
            <p>Let the fun begin</p>
          </Col>
          <Col md={6} xl={30} className="right">
            <img src={logo} className="geekylogo" alt="Logo"></img>
          </Col>
        </Row>
      </div>
    </Col>
  );
};
